module.exports = __webpack_public_path__ + "img/ThumbnailMusicRush.f116a76a.jpg";